module.exports = __webpack_public_path__ + "img/icon_food.9482ad5c.svg";